import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['DMOperation', 'GPS'],
});

export const operationDashboardApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllJobsByDatetime: builder.query({
      query: (payload) => {
        let url = `operation_dashboard/?mode=${payload.mode}`;
        let param = '';
        Object.keys(payload).forEach((key) => {
          if (payload[key] != null && key !== 'mode') {
            param += `&${key}=${payload[key]}`;
          }
        });
        return { url: url + param };
      },
      keepUnusedDataFor: 0,
      providesTags: ['DMOperation'],
    }),
    findOrderLocations: builder.query({
      query: () => `orders/locations/`,
      providesTags: ['DMOperation'],
    }),
    findAllTruckStatuses: builder.query({
      query: () => `truck_statuses/`,
      keepUnusedDataFor: 3600, // 1hr
      providesTags: ['DMOperation'],
    }),
    findRealtimeTrackingId: builder.query({
      query: (id) => `realtime_trackings/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'DMOperation', id: result.id }]
          : ['DMOperation'];
      },
    }),
    findTruckScheduleById: builder.query({
      query: (id) => `truck_schedules/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'DMOperation', id: result.id }]
          : ['DMOperation'];
      },
    }),
    findGpsDataById: builder.query({
      query: ({ gpsProvider, blackBoxId }) =>
        `gps_data/?gpsProvider=${gpsProvider}&blackBoxId=${blackBoxId}`,
      keepUnusedDataFor: 0, // No cache
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'GPS', id: result.id }] : ['GPS'];
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllJobsByDatetimeQuery,
  useFindOrderLocationsQuery,
  useFindAllTruckStatusesQuery,
  useFindRealtimeTrackingIdQuery,
  useFindTruckScheduleByIdQuery,
  useFindGpsDataByIdQuery,
} = operationDashboardApi;
